import { LazyWrapper } from 'app/view/react_components/lazy/lazy_wrapper';
import React from 'react';
import { Provider } from "react-redux";
import { CardDetailsBaseView } from './base';

export const NotificationCardDetailsView = CardDetailsBaseView.extend({

    initialize: function (options) {
        CardDetailsBaseView.prototype.initialize.call(this, options);
        this.notificationId = options.notificationId;
    },

    reactRender: function () {
        const ImportElement = React.lazy(() =>
            this.initStore()
                .then(() => import(/* webpackChunkName: "cardDetails" */ '../../react_components/aside_panel/assigneToMe/notification/hocs/NotificationHOC/NotificationHOC'))
                .then(module => ({default: module.NotificationHOC}))
                .catch(e => console.error(e))
        );

        this.root.render(
            <LazyWrapper>
                <Provider store={this.store}>
                    <ImportElement notificationId={this.notificationId} />
                </Provider>
            </LazyWrapper>
        );
    }

});
